export const DELAY_LIST: ExecutionContainerOption[] = [
    { name: "No delay", value: "0" },
    { name: "1", value: "1000" },
    { name: "2", value: "2000" },
    { name: "3", value: "3000" },
    { name: "5", value: "5000" },
    { name: "7", value: "7000" },
    { name: "10", value: "10000" }
]